import { Box, Container, Grid, Typography } from "@mui/material";

const ProductIntro = ({ title, description, image, reverse = false }) => {
  return (
    <Box sx={{ py: { xs: 6, md: 10 } }}>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={5}
          alignItems="center"
          direction={reverse ? "row-reverse" : "row"}
        >
          <Grid item size={{ xs: 12, md: 6 }}>
            <Box
              component="img"
              src={image}
              alt={title}
              loading="lazy"
              decoding="async"
              sx={{
                width: "100%",
                maxWidth: 500,
                maxHeight: { xs: 250, sm: 300, md: 350 },
                objectFit: "contain",
                objectPosition: "center",
                borderRadius: 4,
                display: "block",
                mx: "auto",
              }}
            />
          </Grid>

          <Grid item size={{ xs: 12, md: 6 }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                color: "#0b4a92",
                mb: 2,
                fontSize: { xs: "1.5rem", md: "2rem" },
              }}
            >
              {title}
            </Typography>

            <Typography
              sx={{
                fontSize: "1.1rem",
                lineHeight: 1.8,
                color: "#4b5563",
                textAlign: "justify",
                whiteSpace: "pre-line",
              }}
            >
              {description}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ProductIntro;
